<template>
    <div class="mainWrap">
        <div class="loginWrap animated fadeInUp fast">

            <center>
                <div class="logo"><img src="img/logo.svg" alt="" /></div>
            </center>

            <div v-if="page == 'gamepin'" style="display: flex; flex-direction: column; margin-top: auto;">

                <input @keydown="check_input" @keyup="ctrlDown = false" @paste="checkPaste" ref="pinInput" v-model="pin" id="pin" type="text" maxlength="4" class="formInputPin" placeholder="PIN" autofocus>
                <h4 style="text-align: center; margin-top: 0; font-weight: 400; margin-bottom: 2.2em;" v-show="error_pin">Ugyldig PIN</h4>
                <div @click="go_to_game" class="formButton">FORTSÆT</div>
                <div @click="page = 'gamemaster'" class="admin">Gamemaster login</div>
            </div>
            <div v-if="page == 'gamemaster'">
                <div class="formWrap">
                    <h4 style="text-align:center; margin-top:0" v-show="error_login">Forkert email eller adgangskode...</h4>
                    <input v-model="email" name="email" type="email" class="formInput" placeholder="Email">
                    <input @keyup.enter="login" v-model="password" name="password" type="password" class="formInput" placeholder="Adgangskode">
                </div>
                <div @click="login" class="formButton">LOGIN</div>
                <div @click="page = 'gamepin'" class="admin">Spil PIN</div>

            </div>
            
        </div>
    </div>

</template>
<script>
    import axios from 'axios'


    export default {
        name: "Login",
        data() {
            return {
                page: "gamepin",
                email: null,
                password: null,
                pin: "",
                error_login: false,
                error_pin: false,
                ctrlDown: false
            }
        },
        methods: {
            go_to_game() {
                // Redirects to game if game pin is correct, else giving error.
                axios
                    .post("/api/games/" + this.pin + "/join")
                    .then(() => {
                        window.location.href = 'games/' + this.pin
                    }, () => {
                        this.error_pin = true
                        this.pin = ""
                        this.$refs.pinInput.focus()
                    })
            },
            check_input(e) {
                const keycode = Number(e.keyCode)

                // Submit on enter
                if (keycode === 13) {
                    this.go_to_game()
                }
                // Allow ctrl + cmd
                else if ((keycode === 17) || (keycode === 91)) {
                    this.ctrlDown = true
                }
                // Ensure key is number or backspace
                else if (!(keycode >= 48 && keycode <= 57) && !(keycode >= 96 && keycode <= 105) && !(keycode === 8) && !(keycode === 46) && !this.ctrlDown) {
                    e.preventDefault()
                    return false
                }
            },
            checkPaste(e) {
                const val = e.clipboardData.getData('text');

                // Only allow numbers
                if (isNaN(val)) {
                    e.preventDefault()
                    return false
                }
            },
            login() {
                const payload = {
                    email: this.email,
                    password: this.password
                }
                axios
                    .post("/api/login", payload)
                    .then(() => (window.location.href = '/projects'), () => (this.wrong_login()))
            },
            wrong_login() {
                this.error_login = true
                this.password = ""
            },
            switch_login() {
                this.admin = !this.admin
                this.error_pin = false
                this.error_login = false
            }
        }
    }
</script>

<style>
@import '../../static/css/styles_login.css';
@import '../../static/css/styles_forms.css';
@import '../../static/css/animate.css';
</style>